import { Activity, Wifi, WifiOff } from 'lucide-react'

interface StatusBadgeProps {
  online: boolean
  pulse?: boolean
}

export function StatusBadge({ online, pulse = false }: StatusBadgeProps) {
  return (
    <span className={`badge ${online ? 'badge-success' : 'badge-danger'}`}>
      {online ? (
        <>
          <span className="relative flex h-2 w-2">
            <span className={`inline-flex absolute inset-0 rounded-full bg-success opacity-75 ${pulse ? 'animate-pulse-ring' : ''}`} />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-success" />
          </span>
          Online
        </>
      ) : (
        <>
          {online ? <Wifi className="w-3 h-3" /> : <WifiOff className="w-3 h-3" />}
          Offline
        </>
      )}
    </span>
  )
}

export function LatencyBadge({ latency }: { latency?: number }) {
  if (latency === undefined || latency === null) return <span className="text-text-muted">—</span>

  let variant = 'badge-success'
  if (latency > 200) variant = 'badge-danger'
  else if (latency > 80) variant = 'badge-warning'

  return (
    <span className={`badge ${variant}`}>
      <Activity className="w-3 h-3" />
      {latency} ms
    </span>
  )
}
